import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationInputClass;
function SaveSlackIntegrationInput() {
  if (SaveSlackIntegrationInputClass === VOID) {
    class $ {
      constructor(partyId, team, channel) {
        this.p6v_1 = partyId;
        this.q6v_1 = team;
        this.r6v_1 = channel;
      }
      toString() {
        return 'SaveSlackIntegrationInput(partyId=' + this.p6v_1.toString() + ', team=' + this.q6v_1 + ', channel=' + this.r6v_1 + ')';
      }
      hashCode() {
        var result = this.p6v_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.q6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r6v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationInput()))
          return false;
        if (!this.p6v_1.equals(other.p6v_1))
          return false;
        if (!(this.q6v_1 === other.q6v_1))
          return false;
        if (!(this.r6v_1 === other.r6v_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationInput');
    SaveSlackIntegrationInputClass = $;
  }
  return SaveSlackIntegrationInputClass;
}
//region block: exports
export {
  SaveSlackIntegrationInput as SaveSlackIntegrationInput3jeifrdutkqgi,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationInput.mjs.map
